import type { ReactElement, ReactNode } from 'react';

export function SectionTitle({ children }: { children: ReactNode }): ReactElement {
    return (
        <div className="flex items-center py-2">
            <p className="flex-1 text-[length:var(--font-size-200)] leading-[var(--line-height-100)] tracking-[0.28px] uppercase font-semibold text-[color:var(--neutral-40)]">
                {children}
            </p>
        </div>
    );
}
